import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NoPreloading, Route, RouterModule } from '@angular/router';
import { homeRoutingModule } from './modules/home/routes';
import { contactRoutingModule } from './modules/contact/routes';
import { itemStockRoutingModule } from './modules/shopping/routes';
import { authenticationRoutingModule } from './modules/authentication/routes';
import { salesRoutingModule } from '@modules/sales/routes';
import { timetrackingRoutingModule } from '@modules/timetracking/routes';
import { bookingViewRoutingModule } from '@modules/BookingView/routes';

export const appRoutes: Route[] = [];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(appRoutes, {
      preloadingStrategy: NoPreloading,
      onSameUrlNavigation: 'reload',
    }),
    homeRoutingModule,
    contactRoutingModule,
    itemStockRoutingModule,
    authenticationRoutingModule,
    salesRoutingModule,
    timetrackingRoutingModule,
    bookingViewRoutingModule,
  ],
  exports: [RouterModule], // Important to export if used in other modules
  declarations: [],
})
export class AppRoutingModule {}
